var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('send-message-x',{attrs:{"uploadAgainDB":_vm.uploadAgainDB,"sendType":_vm.sendType},on:{"onViewRecord":_vm.handleViewRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }